import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEditBig: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconEditBig"><Path d="M22.0607 6.00011L18 1.93945L8 11.9395V16.0001H12.0607L22.0607 6.00011Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H12V4.5H4.5V19.5H19.5V12H21V21H3V3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconEditBig;
